'use client';

import { useEffect } from 'react';
import {useConfig} from "./ConfigProvider";

const Hotjar = () => {
    const cfg = useConfig()

    useEffect(() => {
        const initHotjar = async () => {
            if (!cfg.hotjar || window.isHotjarInitialized) return;

            console.log('Configure hotjar start');

            (function (h, o, t, j, a, r) {
                h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
                h._hjSettings = { hjid: cfg.hotjar.webSiteId, hjsv: 6 };
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script'); r.async = 1;
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
            })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

            window.isHotjarInitialized = true;

            console.log('Configure hotjar end');
        };

        initHotjar();
    }, []);

    return null;
};

export default Hotjar;
